import { socket } from '@/api/socket';
import { SOCKET_EVENTS } from '@/api/socket-events';

export function requestCardEnrich(cardId: number, kinds: Array<'date' | 'pan'>, force = false) {
	socket.emit(SOCKET_EVENTS.requestCardEnrich, { cardId, kinds, force });
}

export function requestPhoneCardFill(phoneId: number, force = false) {
	socket.emit(SOCKET_EVENTS.requestPhoneCardFill, { phoneId, force });
}

export function requestCardBalance(cardId: number, force = false) {
	socket.emit(SOCKET_EVENTS.requestCardBalance, { cardId, force });
}
